import $ from "jquery";
import {$doc} from "./_globals.js";

const DROPDOWN_SELECTOR = ".dropdown";
const TOGGLE_SELECTOR = ".dropdown-toggle";
const ACTIVE_CLASS = "active";
const TARGET_DATA_KEY = "dropdown";

const EVENT_SHOW = "show.void.dropdown";
const EVENT_SHOWN = "shown.void.dropdown";
const EVENT_HIDE = "hide.void.dropdown";
const EVENT_HIDDEN = "hidden.void.dropdown";

$doc.on("click", TOGGLE_SELECTOR, $evt => {
  const $toggle = $($evt.currentTarget);
  const $dropdown = $($toggle.data(TARGET_DATA_KEY));

  if (!$dropdown.length) {
    console.warn("Dropdown target not found.");
    return;
  }

  const closing = $dropdown.hasClass(ACTIVE_CLASS);
  const preEvent = closing ? EVENT_HIDE : EVENT_SHOW;
  const postEvent = closing ? EVENT_HIDDEN : EVENT_SHOWN;

  $dropdown
    .trigger(preEvent)
    .toggleClass(ACTIVE_CLASS)
    .trigger(postEvent);
});

$doc.on("mousedown", $evt => {
  const $target = $($evt.target);
  const $toggle = $target.closest(TOGGLE_SELECTOR);
  const $dropdown = $target.closest(DROPDOWN_SELECTOR);

  let $dropdownsToClose = $(DROPDOWN_SELECTOR + "." + ACTIVE_CLASS);
  if ($toggle.length) $dropdownsToClose = $dropdownsToClose.not($toggle.data(TARGET_DATA_KEY));
  if ($dropdown.length) $dropdownsToClose = $dropdownsToClose.not($dropdown);

  $dropdownsToClose
    .trigger(EVENT_HIDE)
    .removeClass(ACTIVE_CLASS)
    .trigger(EVENT_HIDDEN);
});
